/*
 * Authentication middleware for protected MyUSE routes.
 *
 * Protected pages must have a LIVE authenticated session:
 *
 *   - auth.user
 *   - auth.auth_token
 *
 * Remember Me is deliberately NOT restored here.
 *
 * This distinction is important:
 *
 * NORMAL SPA NAVIGATION
 * ---------------------
 * A logged-in user already has user + token in Vuex, so moving between:
 *
 *   /dashboard
 *   /page/*
 *
 * continues normally.
 *
 * FULL BROWSER REFRESH
 * --------------------
 * On a fresh Nuxt request the persisted browser state has not yet been
 * restored into the server-side Vuex store.
 *
 * Instead of silently logging the remembered user back in and immediately
 * reopening the protected route, redirect them to "/".
 *
 * The landing page can then detect the Remember Me session and show the
 * existing "Welcome back!" RevisitDialog.
 *
 * The user explicitly presses Continue before the remembered session is
 * restored.
 */

export default function ({
  store,
  redirect,
  route,
}) {
  const auth =
    store &&
    store.state
      ? store.state.auth
      : null

  const user =
    auth
      ? auth.user
      : null

  const token =
    auth
      ? auth.auth_token
      : null

  /*
   * A complete LIVE authenticated session is allowed through.
   *
   * This covers ordinary client-side navigation while the user is actively
   * using MyUSE.
   */
  if (
    user &&
    token
  ) {
    return
  }

  /*
   * No live session exists.
   *
   * Do NOT use the Remember Me cookie here.
   * Do NOT perform automatic login here.
   *
   * A remembered session must return through the landing page so the user
   * sees the Welcome Back dialog and explicitly chooses whether to resume.
   */
  const intendedRoute =
    route &&
    route.fullPath &&
    route.fullPath !== '/'
      ? route.fullPath
      : null

  return redirect(
    '/',
    intendedRoute
      ? {
          redirect:
            intendedRoute,
        }
      : undefined
  )
}